package com.iptvplayer.shared.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class FavoriteQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    userId: String,
    contentId: String,
    contentType: String,
    contentName: String,
    contentLogoUrl: String?,
    streamUrl: String,
    addedAt: Long,
  ) -> T): Query<T> = Query(1_091_762_673, arrayOf("FavoriteEntity"), driver, "Favorite.sq",
      "selectAll",
      "SELECT FavoriteEntity.id, FavoriteEntity.userId, FavoriteEntity.contentId, FavoriteEntity.contentType, FavoriteEntity.contentName, FavoriteEntity.contentLogoUrl, FavoriteEntity.streamUrl, FavoriteEntity.addedAt FROM FavoriteEntity ORDER BY addedAt DESC") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getLong(7)!!
    )
  }

  public fun selectAll(): Query<FavoriteEntity> = selectAll { id, userId, contentId, contentType,
      contentName, contentLogoUrl, streamUrl, addedAt ->
    FavoriteEntity(
      id,
      userId,
      contentId,
      contentType,
      contentName,
      contentLogoUrl,
      streamUrl,
      addedAt
    )
  }

  public fun <T : Any> selectByContentId(contentId: String, mapper: (
    id: String,
    userId: String,
    contentId: String,
    contentType: String,
    contentName: String,
    contentLogoUrl: String?,
    streamUrl: String,
    addedAt: Long,
  ) -> T): Query<T> = SelectByContentIdQuery(contentId) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getLong(7)!!
    )
  }

  public fun selectByContentId(contentId: String): Query<FavoriteEntity> =
      selectByContentId(contentId) { id, userId, contentId_, contentType, contentName,
      contentLogoUrl, streamUrl, addedAt ->
    FavoriteEntity(
      id,
      userId,
      contentId_,
      contentType,
      contentName,
      contentLogoUrl,
      streamUrl,
      addedAt
    )
  }

  public fun insert(
    id: String,
    userId: String,
    contentId: String,
    contentType: String,
    contentName: String,
    contentLogoUrl: String?,
    streamUrl: String,
    addedAt: Long,
  ) {
    driver.execute(1_965_550_413, """
        |INSERT OR REPLACE INTO FavoriteEntity(id, userId, contentId, contentType, contentName, contentLogoUrl, streamUrl, addedAt)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 8) {
          bindString(0, id)
          bindString(1, userId)
          bindString(2, contentId)
          bindString(3, contentType)
          bindString(4, contentName)
          bindString(5, contentLogoUrl)
          bindString(6, streamUrl)
          bindLong(7, addedAt)
        }
    notifyQueries(1_965_550_413) { emit ->
      emit("FavoriteEntity")
    }
  }

  public fun deleteByContentId(contentId: String) {
    driver.execute(-1_413_745_378, """DELETE FROM FavoriteEntity WHERE contentId = ?""", 1) {
          bindString(0, contentId)
        }
    notifyQueries(-1_413_745_378) { emit ->
      emit("FavoriteEntity")
    }
  }

  public fun deleteAll() {
    driver.execute(-1_845_938_462, """DELETE FROM FavoriteEntity""", 0)
    notifyQueries(-1_845_938_462) { emit ->
      emit("FavoriteEntity")
    }
  }

  private inner class SelectByContentIdQuery<out T : Any>(
    public val contentId: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("FavoriteEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("FavoriteEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(40_188_205,
        """SELECT FavoriteEntity.id, FavoriteEntity.userId, FavoriteEntity.contentId, FavoriteEntity.contentType, FavoriteEntity.contentName, FavoriteEntity.contentLogoUrl, FavoriteEntity.streamUrl, FavoriteEntity.addedAt FROM FavoriteEntity WHERE contentId = ?""",
        mapper, 1) {
      bindString(0, contentId)
    }

    override fun toString(): String = "Favorite.sq:selectByContentId"
  }
}
